import type { ReactNode } from "react";
import { useSection, useSections } from "./hooks";

export function Inactive({ children }: { children: ReactNode }) {
    const { active, setActive } = useSections();
    const { sectionId } = useSection();

    if (active === sectionId) return null;

    return (
        <>
            <button
                aria-expanded="false"
                onClick={() => {
                    setActive(sectionId);
                }}
                className="bg-inherit w-full text-left p-2 hover:bg-compendia-greige-20 hover:shadow"
            >
                {children}
            </button>
        </>
    );
}
